//////////////////////////////////////////////////////////////////////
// Configurations related to search                                 //
// Note: some search experience is also on defaultMapsConfig        //
// and defaultListingConfig.js is responsible public data filtering //
//////////////////////////////////////////////////////////////////////

// NOTE: if you want to change the structure of the data,
// you should also check src/util/configHelpers.js
// some validation is added there.

// Main search used in Topbar.
// This can be either 'keywords' or 'location'.
export const mainSearch = {
  searchType: 'location',
};

/**
 * Configuration for default filters.
 * These are custom configs for each filter.
 * Common properties: key, schemaType, and label.
 * Note: the order of default filters is defined in util/configHelpers.js
 */

export const dateRangeFilter = {
  schemaType: 'dates',
  // Should the entire date range be available, or just part of it (SearchPage.duck → listings.query)
  availability: 'time-full', // time-partial
  // Options: day/night. This affects counting and whether single day picking is possible.
  dateRangeMode: 'day',
};

export const priceFilter = {
  schemaType: 'price',
  // Note: unlike most prices this is not handled in subunits
  min: 0,
  max: 1000,
  step: 5,
};

/**
 * Filtro propio de Cocopool ("Con descuento"): botón de dos estados que deja solo los
 * anuncios con dto. de primera reserva o dto. entre semana. No es un listing field ni un
 * filtro de Sharetribe, así que no llega por hosted assets: se añade a `defaultFilters` en
 * `util/configHelpers.js` y se aplica en cliente en `SearchPage.duck.js` (Flex no puede
 * hacer OR entre dos campos de extended data, y la elegibilidad de la primera reserva
 * depende del perfil del anfitrión, no del anuncio).
 */
export const discountFilter = {
  key: 'discount',
  schemaType: 'discount',
};

/**
 * Chips rápidos "Apto para lluvia" y "Con espacio interior" de la barra de búsqueda. Como
 * "Con descuento", son de dos estados (el param solo existe cuando están activos) y nunca
 * llegan crudos a Flex: el duck los traduce a "`pub_weatherProtectedFor`, `pub_hasIndoorSpace`,
 * `pub_extras` (techada / comedor / salon) o tipo interiores" (ver `shelterSearchQueries` en
 * SearchPage.duck.js y docs/search-filters.md).
 */
export const rainProofFilter = {
  key: 'lluvia',
  schemaType: 'quickToggle',
};
export const indoorSpaceFilter = {
  key: 'interior',
  schemaType: 'quickToggle',
};
// // This is not in use by default.
// export const keywordsFilter = {
//   key: 'keywords',
//   schemaType: 'keywords',
// }

export const sortConfig = {
  // Enable/disable the sorting control in the SearchPage
  active: true,

  // Note: queryParamName 'sort' is fixed,
  // you can't change it since Marketplace API expects it to be named as 'sort'
  queryParamName: 'sort',

  // Internal key for the relevance option, see notes below.
  relevanceKey: 'relevance',

  // Internal key for the "distance" option. It represents the default order (by distance from
  // origin) and maps to "no sort param" — selecting it clears `sort` (handled in handleSortBy),
  // and it's shown as selected whenever there is no explicit sort.
  distanceKey: 'distance',

  // Relevance key is used with keywords filter.
  // Keywords filter also sorts results according to relevance.
  relevanceFilter: 'keywords',

  // Keyword filter is sorting the results by relevance.
  // If keyword filter is active, one might want to disable other sorting options
  // by adding 'keywords' to this list.
  conflictingFilters: [],

  options: [
    // Default order (no sort param → results sorted by distance from origin). Selecting it clears
    // `sort`; see distanceKey above and handleSortBy in the SearchPage containers.
    { key: 'distance', labelTranslationKey: 'SortBy.distance' },

    // These are default sort options
    { key: '-pub_score', labelTranslationKey: 'SortBy.relevance' },

    // Host rating lives on the author profile (averageRating/totalReviews), not on the listing,
    // so this is sorted client-side in SearchPage.duck.js (RATINGS_SORT_KEY), not by Flex.
    { key: 'meta_rating', labelTranslationKey: 'SortBy.ratings' },
    { key: '-createdAt', labelTranslationKey: 'SortBy.newest' },
    { key: 'createdAt', labelTranslationKey: 'SortBy.oldest' },
    { key: 'price', labelTranslationKey: 'SortBy.lowestPrice' },
    { key: '-price', labelTranslationKey: 'SortBy.highestPrice' },
    // If you add own sort options, you can also use label key: { key: 'meta_rating', label: 'Highest rated' },

    // The relevance is only used for keyword search, but the
    // parameter isn't sent to the Marketplace API. The key is purely
    // for handling the internal state of the sorting dropdown.
    {
      key: 'relevance',
      labelTranslationKey: 'SortBy.relevance',
      labelTranslationKeyLong: 'SortBy.relevanceLong',
    },
  ],
};
